module.exports = __webpack_public_path__ + "img/Bear35.5f4e867d.jpg";